export class MetricExportDestination {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "destinationType",
            "baseName": "destinationType",
            "type": "MetricExportDestinationType",
            "format": ""
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "otlpEndpoint",
            "baseName": "otlpEndpoint",
            "type": "string",
            "format": "uri"
        },
        {
            "name": "otlpProtocol",
            "baseName": "otlpProtocol",
            "type": "TelemetryExportOtlpProtocol",
            "format": ""
        },
        {
            "name": "authMode",
            "baseName": "authMode",
            "type": "TelemetryExportAuthMode",
            "format": ""
        },
        {
            "name": "secretRef",
            "baseName": "secretRef",
            "type": "MetricExportDestinationSecretRef",
            "format": ""
        },
        {
            "name": "collectorPrincipal",
            "baseName": "collectorPrincipal",
            "type": "string",
            "format": ""
        },
        {
            "name": "exportedMetricNames",
            "baseName": "exportedMetricNames",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "applyStatus",
            "baseName": "applyStatus",
            "type": "TelemetryExportApplyStatus",
            "format": ""
        },
        {
            "name": "applyErrorCode",
            "baseName": "applyErrorCode",
            "type": "string",
            "format": ""
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return MetricExportDestination.attributeTypeMap;
    }
    constructor() {
    }
}
